import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Notification } from '../models/notifications/notification.model';


@Injectable({ providedIn: 'root' })
export class NotificationService implements OnDestroy {
  private notificationSubject = new BehaviorSubject<Notification>(null);
  private timeout;

  notification$ = this.notificationSubject.asObservable();

  ngOnDestroy(): void {
    this.notificationSubject.complete();
  }

  show(notification: Notification) {
    this.notificationSubject.next(notification);

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.notificationSubject.next(null);
      this.timeout = null;
    }, notification.timeoutMs ? notification.timeoutMs : 3000);
  }
}